class ScrollingBar extends HTMLElement {
    constructor() {
        super();
        this.mobileScroller = this.querySelector('.scrolling-bar__container');
        this.content = this.mobileScroller.innerHTML
        this.textBlocks = `${this.content} ${this.content} ${this.content} ${this.content} ${this.content} ${this.content}`;
        this.updateDesktopScroller = this.updateDesktopScroller.bind(this);
    }

    connectedCallback() {
        this.updateDesktopScroller();
        window.addEventListener('resize', this.updateDesktopScroller);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.updateDesktopScroller);
    }

    updateDesktopScroller() {
        if (!this.mobileScroller) return;

        if (window.innerWidth < 750 && this.mobileScroller.getAttribute('data-animated') === 'false') {
            this.mobileScroller.innerHTML += this.textBlocks;
            this.mobileScroller.setAttribute('data-animated', 'true');
            this.mobileScroller.setAttribute('generated', 'true');
        } else if (window.innerWidth > 750 && this.mobileScroller.getAttribute('generated') === 'true') {
            this.mobileScroller.setAttribute('data-animated', 'false');
            this.mobileScroller.setAttribute('generated', 'false');
            this.mobileScroller.innerHTML = this.content;
        }
    }

}

customElements.define('scrolling-bar', ScrollingBar);